import { Button } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import Overlay from '../../../shared/components/Overlay';
import styles from '../logs.module.scss';
import ChangeLogsTable from './ChangeLogsTable';
import { LogSearchApiRequest } from '../apiSlice';
import useGetLogs from '../../../shared/hooks/useGetLogs';
import LogSearchField from '../LogSearchField';
import { SearchItemMap } from '../LogSearchField/models';

export default function ChangeLogs() {
  const [initialRequest, setInitialRequest] = useState(true);
  const [search, setSearch] = useState<LogSearchApiRequest | null>({
    logType: 'Change',
  });
  const [logList, setLogList] = useState([]);
  const { storedData, hasMore, handleLoadMore, isLoading } = useGetLogs(
    search,
    initialRequest,
  );

  const columns = [
    { label: 'Action', value: 'action' },
    { label: 'Agreement ID', value: 'search' },
    { label: 'Performed By', value: 'user' },
    { label: 'Date/Time', value: 'startDate' },
  ];
  const mapColumns: SearchItemMap[] = [
    { column: 'action', with: 'action' },
    { column: 'search', with: 'search' },
    { column: 'startDate', with: 'startDate' },
    { column: 'user', with: 'user' },
  ];

  const onSearch = (searchData: { [key: string]: string } | null) => {
    if (searchData) {
      const clone: LogSearchApiRequest = { ...searchData };
      clone.logType = 'Change';
      if (clone?.search?.length > 0) {
        clone.searchField = 'DealId';
      }

      setInitialRequest(true);
      setSearch(clone);
      return;
    }
    setSearch(null);
  };
  useEffect(() => {
    setLogList(storedData?.filter((log) => log.logType === 'Change'));
  }, [search, isLoading, storedData]);

  return (
    <>
      <LogSearchField
        onSearch={onSearch}
        columns={columns}
        mapColumns={mapColumns}
      />
      <h5 className=" fw-normal fs-4 my-3">
        <strong className="fw-bold">
          <span>Change Log</span>
        </strong>
      </h5>
      <div className={styles['card-container']}>
        {!isLoading && logList?.length === 0 && (
          <p className={`${styles['no-log-msg']}`}>No change logs available</p>
        )}
      </div>
      {logList?.length !== 0 && <ChangeLogsTable logs={logList} />}
      {!isLoading && hasMore && logList && logList?.length > 0 && (
        <div className="text-center pt-3">
          <Button
            variant="primary"
            onClick={() => {
              setInitialRequest(false);
              handleLoadMore();
            }}
            titleText="Load More"
          />
        </div>
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isLoading}
      />
    </>
  );
}
